import { format, formatDistanceToNowStrict, isToday, isYesterday } from 'date-fns'
import { it } from 'date-fns/locale'
import type { Conversation, Message } from '../types'

export const formatConversationTime = (value?: string): string => {
  if (!value) return ''
  const date = new Date(value)
  if (isToday(date)) return format(date, 'HH:mm')
  if (isYesterday(date)) return 'Ieri'
  return format(date, 'dd/MM/yy')
}

export const formatMessageTime = (value: string): string => format(new Date(value), 'HH:mm')

export const formatDay = (value: string): string => {
  const date = new Date(value)
  if (isToday(date)) return 'Oggi'
  if (isYesterday(date)) return 'Ieri'
  return format(date, 'd MMMM yyyy', { locale: it })
}

export const relativeTime = (value?: string): string => {
  if (!value) return 'Mai'
  return formatDistanceToNowStrict(new Date(value), { addSuffix: true, locale: it })
}

export const addressLabel = (conversation: Conversation): string =>
  conversation.contact.address.phoneNumber ??
  conversation.contact.address.username ??
  conversation.contact.address.bsuid ??
  'Identità WhatsApp'

export const messagePreview = (message?: Message): string => {
  if (!message) return 'Nessun messaggio'
  if (message.text) return message.text
  const labels: Record<Message['type'], string> = {
    text: 'Messaggio',
    image: 'Immagine',
    audio: 'Messaggio vocale',
    document: 'Documento',
    video: 'Video',
    sticker: 'Sticker',
    template: 'Template WhatsApp',
    button: 'Risposta rapida',
    notice: 'Avviso WhatsApp',
    unsupported: 'Messaggio non supportato',
  }
  return labels[message.type]
}

export const serviceWindowLabel = (expiresAt?: string): { open: boolean; label: string } => {
  if (!expiresAt) return { open: false, label: 'Finestra di risposta non disponibile' }
  const expires = new Date(expiresAt)
  if (expires.getTime() <= Date.now()) {
    return { open: false, label: 'Finestra di risposta chiusa' }
  }
  const remaining = formatDistanceToNowStrict(expires, { locale: it })
  return { open: true, label: `Finestra aperta · ${remaining} rimanenti` }
}
